import { createContext, useState } from 'react';

import OrgUnitOmeMeetEntryData from './OrgUnitOmeMeetEntryData';

export const OrgUnitOmeMeetEntryStateContext = createContext();

const OrgUnitOmeMeetEntryContextProvider = ({ children }) => {
  const stateHook = useState(OrgUnitOmeMeetEntryData.INITIAL_STATE);

  return (
    <OrgUnitOmeMeetEntryStateContext.Provider value={stateHook}>
      {children}
    </OrgUnitOmeMeetEntryStateContext.Provider>
  );
};

export default OrgUnitOmeMeetEntryContextProvider;